import styled, { css } from 'styled-components';

export const Container = styled.div<{
  width: string;
  height: string;
  shadow: string;
  disabled: boolean;
  clickable: boolean;
}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  box-shadow: ${({ shadow }) => shadow};
  border-radius: 50%;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ color }) => color};

  cursor: ${({ disabled, clickable }) => {
    if (disabled) return 'not-allowed';
    if (clickable) return 'pointer';
    return 'default';
  }};

  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const IconContainer = styled.div<{
  disabled: boolean;
  clickable: boolean;
  rotateIcon?: number;
  width: string;
  height: string;
  color: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;

  transform: ${({ rotateIcon }) =>
    rotateIcon ? `rotate(${rotateIcon}deg)` : 'none'};

  ${({ clickable }) =>
    clickable &&
    css`
      @media (hover: hover) {
        &:hover svg,
        ${Container}:hover & svg {
          opacity: 0.7;
        }
      }
    `};

  svg {
    width: ${({ width }) => width};
    height: ${({ height }) => height};

    path {
      fill: ${({ color }) => color};
    }
  }
`;
